module.exports = __webpack_public_path__ + "img/fire20.afc2d7d2.gif";